
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { createHead } from "@vueuse/head"


import {createApp} from 'vue';

require('./bootstrap');
import UserScoresChart from './components/UserScoresChart.vue';


import App from './App.vue';
import axios from 'axios';
import router from './router';
import auth from './auth';
import { vue3Debounce } from 'vue-debounce'

const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.use(router);
const options = {
    // You can set your default options here
    timeout: false,
    rtl: true,
    closeButton: false,
    position: "top-right",
    // hideProgressBar: true,
};
//
app.use(Toast, options);

app.component('user-scores-chart', UserScoresChart);

app.use(auth, {
    afterChecked: function(){
        // app.mount('#app');
    }
})

const head = createHead()

app.use(head);

app
    .directive('debounce', vue3Debounce({ lock: true }))
    .mount('#app');
